// extracted by mini-css-extract-plugin
export var footerContent = "footer-module--footer-content--Czsan";
export var preferredContactMethod = "footer-module--preferred-contact-method--VwMMF";
export var preferredContactMethodContact = "footer-module--preferred-contact-method-contact--JsBfZ";
export var socialIcons = "footer-module--social-icons--q96qi";
export var socialIconsWrap = "footer-module--social-icons-wrap--V6e5J";